/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Form from "components/Form";
import LayoutContext from "context/LayoutContext";
import { ACTION_ADD } from "constant/dataTableActionConstant";

function indexTable() {
  const layoutContext = useContext(LayoutContext);
  const { t } = useTranslation("translation");
  const { title, columns, rows, handleDialogForm, onSelectedRow, handleSearch, refreshData } =
    layoutContext;
  // console.log("componentModule", formConfig, isOpenForm);
  const openForm = () => {
    onSelectedRow({}, ACTION_ADD);
    handleDialogForm(true, ACTION_ADD);
  };
  // console.log("dddddd tableCOmponent", refreshData);
  return (
    <div>
      <Typography variant="h2">{title}</Typography>
      <MDButton
        type="submit"
        variant="gradient"
        color="info"
        sx={{ marginLeft: "auto", marginRight: 10 }}
        // style={{}}
        onClick={openForm}
      >
        {t("add")}
      </MDButton>
      {rows.length > 0 && (
        <Box pt={3}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage
            showTotalEntries
            noEndBorder
            canSearch
            handleSearch={handleSearch}
            refreshData={refreshData}
          />
        </Box>
      )}
      <Form />
    </div>
  );
}

const indexTableComponent = React.memo(indexTable);
export default indexTableComponent;
